import React, { useState, useEffect } from 'react';

interface Size {
    width: number;
    height: number;
}

interface Sizes {
    phone: Size;
    desktop: Size;
}

const sizes = {
    xxsmall: { phone: { width: 10, height: 13 }, desktop: { width: 15, height: 20 } },
    xsmall: { phone: { width: 15, height: 20 }, desktop: { width: 20, height: 27 } },
    small: { phone: { width: 20, height: 27 }, desktop: { width: 30, height: 40 } },
    medium: { phone: { width: 30, height: 40 }, desktop: { width: 43, height: 58 } },
    large: { phone: { width: 43, height: 58 }, desktop: { width: 60, height: 81 } },
    xlarge: { phone: { width: 60, height: 81 }, desktop: { width: 80, height: 108 } },
    xxlarge: { phone: { width: 80, height: 108 }, desktop: { width: 100, height: 135 } },
    xxxlarge: { phone: { width: 100, height: 135 }, desktop: { width: 120, height: 160 } }
};

type SizeKeys = keyof typeof sizes;

interface ICurvedIconProps {
    className?: string;
    style?: React.CSSProperties;
    size?: SizeKeys;
}

const ICurvedIcon: React.FC<ICurvedIconProps> = ({ className, style, size = 'medium' }) => {
    const [isDesktop, setIsDesktop] = useState<boolean | null>(null);

    useEffect(() => {
        const updateIsDesktop = () => {
            setIsDesktop(window.innerWidth >= 1000);
        };

        if (typeof window !== 'undefined') {
            updateIsDesktop();
            window.addEventListener('resize', updateIsDesktop);
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', updateIsDesktop);
            }
        };
    }, []);

    if (isDesktop === null) {
        return null; // Or a loading spinner, or any placeholder until the first resize event occurs.
    }

    const { phone, desktop } = sizes[size];
    const { width, height } = isDesktop ? desktop : phone;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 43 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
        >
            <path
                d="M20.4399 57.5442C16.8121 57.5442 14.9825 55.7604 14.0951 54.2726C12.3676 51.3771 11.5431 45.9218 18.5946 29.9721C14.0402 32.4117 8.62984 34.3714 3.5179 35.2433L0.887327 35.6913L0 30.324L2.63057 29.8761C11.6766 28.3243 20.7069 23.293 23.5809 19.5415C23.6516 19.4055 23.7222 19.2616 23.7929 19.1256L28.6928 21.2373L28.473 21.9092L28.261 22.2211C28.2138 22.2851 28.1746 22.3571 28.1275 22.4211C24.1306 30.324 16.1446 47.2096 18.6653 51.441C18.7831 51.641 19.0579 52.097 20.4399 52.097C22.1832 52.097 26.6748 50.1612 37.1735 37.171L38.8696 35.0753L42.9921 38.5309L41.296 40.6266C31.716 52.4809 25.4733 57.5362 20.4399 57.5362V57.5442ZM32.2186 12.1506L27.405 9.80689L31.7474 0.544189L36.561 2.88786L32.2186 12.1426V12.1506Z"
                fill="#294C72"
            />
        </svg>
    );
};

export default ICurvedIcon;
